import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import { IPrecatorio } from "../interfaces/IPrecatorio";
import { IQuote } from "../interfaces/trade/precificacao/IQuote";
import { IQuoteList } from "../interfaces/trade/precificacao/IQuoteList";
import {IBaseResponse} from './IBaseResponse';

enum QuoteServiceEnum {
  postCreateFromQuote = "/create-from-quote",
  getAll = "/get-all-from-officer",
  getAllByUser = "/get-all-by-user",
  getAllList = "/get-all-list",
  postUpdateQuoteRecalculated = "/update-quote-recalculated",
  postSaveQuoteManual = "/save-quote-manual",
  postSaveQuoteDap = "/save-quote-dap",
  getById = "/get-by-id/",
  postSendQuote = "/send-quote",
}

export default class QuoteService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/quote");
  }

  public postShowQuoteFromPrecatorio = async (precatorio: IPrecatorio): Promise<IQuote> => await this.POST(QuoteServiceEnum.postCreateFromQuote, precatorio);
  public getAll = async (): Promise<IQuote[]> => await this.GET(QuoteServiceEnum.getAll);
  public getAllByUser = async (): Promise<IQuote[]> => await this.GET(QuoteServiceEnum.getAllByUser);
  public getAllList = async (): Promise<IQuoteList[]> => await this.GET(QuoteServiceEnum.getAllList);
  public postUpdateQuoteRecalculated = async (obj): Promise<IQuote> => await this.POST(QuoteServiceEnum.postUpdateQuoteRecalculated, obj);
  public postSaveManual = async (precatorio: IPrecatorio): Promise<IBaseResponse> => await this.POST(QuoteServiceEnum.postSaveQuoteManual, precatorio);
  public postSaveQuoteDap = async (precatorio: IPrecatorio): Promise<IQuote> => await this.POST(QuoteServiceEnum.postSaveQuoteDap, precatorio);
  public getById = async (id: number): Promise<IQuote> => await this.GET(QuoteServiceEnum.getById + id);
  public postSendQuote = async (quote: Partial<IQuote>) => await this.POST(QuoteServiceEnum.postSendQuote, quote);
}



// WEBPACK FOOTER //
// ./src/services/api/Quote.service.ts